import { render, staticRenderFns } from "./SttP2PEngineSetting.vue?vue&type=template&id=45081658&scoped=true"
import script from "./SttP2PEngineSetting.vue?vue&type=script&lang=js"
export * from "./SttP2PEngineSetting.vue?vue&type=script&lang=js"
import style0 from "./SttP2PEngineSetting.vue?vue&type=style&index=0&id=45081658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45081658",
  null
  
)

export default component.exports